import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaCalendarAlt,
    FaUsers,
    FaBoxes,
    FaMapMarkedAlt,
    FaStore,
    FaCheckCircle
} from "react-icons/fa";

const statsData = [
    { value: 7, label: "Years of Experience", icon: <FaCalendarAlt /> },
    { value: 5000, label: "Farmers Supported", icon: <FaUsers /> },
    { value: 200, label: "Product Range", icon: <FaBoxes /> },
    { value: 8, label: "States Presence", icon: <FaMapMarkedAlt /> },
    { value: 250, label: "Dealer Network", icon: <FaStore /> },
    { value: 100, label: "Quality Commitment (%)", icon: <FaCheckCircle /> },
];

const Counter = ({ end }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const duration = 1500;
        const increment = end / (duration / 30);

        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 30);

        return () => clearInterval(timer);
    }, [end]);

    return <h3>{count}+</h3>;
};

const StatsCounter = () => {
    return (
        <section className="section stats-section">
            <Container>

                {/* ✅ HEADING ADDED */}
                <div className="section-title fade-up text-center">
                    <h2>Our Achievements</h2>
                    <p>
                        Growing consistently with farmer trust, quality commitment,
                        and nationwide reach.
                    </p>
                </div>

                <Row>
                    {statsData.map((item, i) => (
                        <Col lg={4} md={6} className="mb-4 fade-up" key={i}>
                            <div className="stats-card">
                                <div className="stats-icon">{item.icon}</div>
                                <Counter end={item.value} />
                                <p>{item.label}</p>
                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>
        </section>
    );
};

export default StatsCounter;
